<template>
<div class="mob-navbar">
	<router-link class="mob-navbar__item" :to="{name: 'bonus'}" >
		<svg class="mob-navbar__item-icon"><use href="#svg-icon-gift"></use></svg>
		<span class="mob-navbar__item-text">Бонусы</span>
	</router-link>
	<router-link class="mob-navbar__item" :to="{name: 'revshare'}" >
		<svg class="mob-navbar__item-icon"><use href="#svg-icon-partners"></use></svg>
		<span class="mob-navbar__item-text">Партнерка</span>
	</router-link>
	<button type="button" class="mob-navbar__item" @click="openWallet">
		<svg class="mob-navbar__item-icon"><use href="#svg-icon-wallet"></use></svg>
		<span class="mob-navbar__item-text">Кошелек</span>
	</button>
	<a class="mob-navbar__item" :href="$root.$link.support"  target="_blank">
		<svg class="mob-navbar__item-icon"><use href="#svg-icon-support"></use></svg>
		<span class="mob-navbar__item-text">Поддержка</span>
	</a>
	<button type="button" class="mob-navbar__item" @click="openMenu">
		<svg class="mob-navbar__item-icon"><use href="#svg-icon-menu"></use></svg>
		<span class="mob-navbar__item-text">Меню</span>
	</button>
</div>

</template>

<script>
export default {

	methods: {
		openMenu() {
			this.$root.emitter.emit('openNav');
		},

		openWallet() {
			this.$root.emitter.emit('openWallet');
		}
	}
}

</script>